import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Hourglass02 = function Hourglass02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M18.1626 2H5.8374A.8374.8374 0 0 0 5 2.8374a10.05 10.05 0 0 0 2.9434 7.106l1.2192 1.2192c.121.121.1816.1816.2249.2397a1 1 0 0 1 0 1.1954c-.0433.0581-.1039.1187-.225.2397l-1.2191 1.2192A10.05 10.05 0 0 0 5 21.1626c0 .4625.375.8374.8374.8374h12.3252A.8374.8374 0 0 0 19 21.1626a10.05 10.05 0 0 0-2.9434-7.106l-1.2192-1.2192c-.121-.121-.1816-.1816-.2249-.2397a1 1 0 0 1 0-1.1954c.0433-.0581.1039-.1187.2249-.2397l1.2192-1.2192A10.05 10.05 0 0 0 19 2.8374.8374.8374 0 0 0 18.1626 2"
    })
  }));
};
export default Hourglass02;